export default "__VITE_ASSET__BQcTf_sH__"